import { Button } from './ui/button';
import { track } from '../lib/api';
import { trackPixelEvent } from '../lib/pixels';

export default function FinalCta({ settings, geo }) {
  const tg = settings?.telegram_link || '#';
  const title = settings?.final_cta_title || 'THE DOOR IS OPEN. WALK THROUGH IT.';
  const subtitle = settings?.final_cta_subtitle || 'Join the AlveeTrade Telegram now. It’s free.';
  const ctaLabel = settings?.cta_primary_label || 'Join Free Telegram Channel';

  function handleJoin() {
    trackPixelEvent('Subscribe', { source: 'final' });
    track({ type: 'tg_click', country_code: geo?.country_code, country_name: geo?.country_name, source: 'final' });
  }

  return (
    <section id="final-cta" className="relative overflow-hidden bg-[hsl(0_0%_4%)] hero-glow noise-overlay section-pad">
      <div className="container-x relative z-10 text-center max-w-3xl mx-auto">
        <div className="text-[11px] uppercase tracking-[0.22em] text-[hsl(43_92%_56%)] mb-3">Final Step</div>
        <h2 className="font-display uppercase text-5xl sm:text-6xl lg:text-7xl leading-[0.95]">{title}</h2>
        <p className="text-base md:text-lg text-[hsl(0_0%_78%)] mt-4">{subtitle}</p>
        <a href={tg} target="_blank" rel="noreferrer" onClick={handleJoin} data-testid="final-join-telegram-button">
          <Button className="cta-sheen border-0 text-white font-semibold h-14 px-8 text-lg mt-8">{ctaLabel}</Button>
        </a>
        <p className="text-xs text-muted-foreground mt-6">Trading involves risk. Educational content only. Past results never guarantee future outcomes.</p>
      </div>
    </section>
  );
}
